import React from "react";

export function TableBody(props: { className: string, rows: JSX.Element[] }) {
    return <tbody className={props.className}>
    {props.rows}
    </tbody>;
}